import React, { PropTypes } from 'react';

const onDeleteClick = onDelete => evt => {
  evt.preventDefault();
  onDelete();
  evt.stopPropagation();
};

const onEditClick = onEdit => evt => {
  evt.preventDefault();
  onEdit();
  evt.stopPropagation();
};

const RefLine = ({ data, onEdit, onDelete }) => (
  <tr className="lineDetail" data-label={data.label}>
    <td>
      <div className="ui buttons">
        <a
          href="#"
          className="ui basic grey button"
          onClick={onEditClick(onEdit)}
        >
          <i className="edit icon" />
          Editer
        </a>

        <a
          href="#"
          className="ui basic red button delete"
          onClick={onDeleteClick(onDelete)}
        >
          <i className="remove icon" />
          Supprimer
        </a>
      </div>
    </td>
    <td className="label">{data.label}</td>
  </tr>
);

RefLine.propTypes = {
  data: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default RefLine;



// WEBPACK FOOTER //
// ./src/modules/saas/common/references/RefLine.js